import i18next from "../_snowpack/pkg/i18next.js";

i18next.services.formatter.add(
  "stripCurrencyFraction",
  (value, lng, options) => {
    return value.replace(/,00/, "");
  }
);
